
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 210 23","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M107.1 3.533h-8.82v5.963h8.82c2.088 0 3.78-1.335 3.78-2.982 0-1.646-1.692-2.981-3.78-2.981zM47.88 4.62l-5.603 10.175h11.208L47.881 4.621zm88.2 0l-5.604 10.175h11.208L136.08 4.621zm-26.88 7.967H98.28v6.847h10.92c2.32 0 4.2-1.532 4.2-3.424 0-1.89-1.88-3.423-4.2-3.423zM4.632.441l9.648 9.685L23.928.441h4.632v22.086h-4.934V5.95l-9.346 9.384-9.345-9.384v16.578H0V.441h4.632zm61.728 0l8.4 9.622L83.163.441h5.37L77.335 13.269v9.258h-5.146v-9.258L60.99.441h5.371zm122.64 0v9.055h15.96V.441H210v22.086h-5.04v-9.939H189v9.939h-5.04V.441H189zm-138.257 0l12.41 22.086h-5.41l-2.555-4.638H40.574l-2.555 4.638h-5.41L45.019.441h5.724zm57.197 0c4.407 0 7.98 2.868 7.98 6.405 0 1.173-.392 2.271-1.078 3.217 2.176 1.237 3.598 3.292 3.598 5.618 0 3.702-3.605 6.718-8.111 6.842l-.289.004H93.241V.441h14.699zm31.003 0l12.409 22.086h-5.41l-2.554-4.638h-14.615l-2.554 4.638h-5.41L133.218.441h5.725zM168.42 0c3.705 0 7.163.647 10.079 1.766V5.54c-2.583-1.513-6.145-2.45-10.08-2.45-5.915 0-10.71 3.76-10.71 8.394 0 4.635 4.795 8.392 10.71 8.392 3.935 0 7.497-.935 10.08-2.447v3.773c-2.916 1.12-6.374 1.767-10.08 1.767-8.815 0-15.96-5.141-15.96-11.485C152.46 5.141 159.606 0 168.42 0z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    